// import React from 'react';

// const DeliveryDaysComponent = ({ stock_delivery_days, business_delivery_days }) => {

//     const totalDays = (stock_delivery_days || 0) + (business_delivery_days || 0);

//     const deliveryText =
//         totalDays === 0
//             ? "Same Day"
//             : `${totalDays} ${totalDays === 1 ? "Working Day" : "Working Days"}`;

//     return (
//         <div
//             className="p-3 rounded-3"
//             style={{
//                 background: "linear-gradient(90deg, #f6fff9 0%, #ffffff 100%)",
//                 border: "1px solid #d4f5dd"
//             }}
//         >
//             <div className="d-flex align-items-center">

//                 {/* Icon Circle */}
//                 <div
//                     className="d-flex align-items-center justify-content-center"
//                     style={{
//                         width: "45px",
//                         height: "45px",
//                         borderRadius: "50%",
//                         backgroundColor: "#28a745",
//                         color: "#fff",
//                         fontSize: "20px"
//                     }}
//                 >
//                     🚚
//                 </div>

//                 {/* Text Content */}
//                 <div className="flex-grow-1 ml-2">

//                     <div className="fw-bold" style={{ fontSize: "15px" }}>
//                         Estimated Delivery
//                     </div>

//                     <div className="text-muted" style={{ fontSize: "14px" }}>
//                         Within{" "}
//                         <span className="text-success" style={{ fontWeight: "bold" }}>
//                             {deliveryText}
//                         </span>
//                     </div>

//                 </div>
//             </div>
//         </div>
//     );
// };

// export default DeliveryDaysComponent;


import React from 'react';

const DeliveryDaysComponent = ({ stock_delivery_days, business_delivery_days }) => {

    const totalDays = (stock_delivery_days || 0) + (business_delivery_days || 0);

    const deliveryText =
        totalDays === 0
            ? "Same Day"
            : `${totalDays} ${totalDays === 1 ? "Working Day" : "Working Days"}`;

    return (
        <div
            className="p-3"
            style={{
                background: "#0ba4be",
                border: "1px solid #d4f5dd",
                borderRadius: "15px"
            }}
        >
            <div className="d-flex align-items-center">
                <div
                    className="d-flex align-items-center justify-content-center"
                    style={{
                        width: "45px",
                        height: "45px",
                        borderRadius: "50%",
                        color: "#fff",
                        fontSize: "20px"
                    }}
                >
                    <img src="/assets/images/truck-icon.gif" alt="" className='' width="45px" height="45px" />
                </div>

                {/* Text Content */}
                <div className="delivery-card-text">

                    <div className="flex-grow-1" style={{ marginLeft: '10px' }}>

                        <div className="fw-bold" style={{ fontSize: "20px", color: '#fff' }}>
                            Estimated Delivery
                        </div>

                        <div className="" style={{ fontSize: "14px", color: '#fff' }}>
                            Within{" "}
                            <span className="" style={{ fontWeight: "bold", color: '#fff' }}>
                                {deliveryText}
                            </span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default DeliveryDaysComponent;